import { DefaultService } from '@/services/DefaultService';

export default class AssPermTelaRecursoFormularioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }


    findAllComboByIdFormulario(idformulario, ...params) {
	    return this._http.get(encodeURI(`${this._env}/ven/areainteresse/getcombo/${idformulario}.json?param=${params}`), this._headers).then(res => {
            return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    saveAreaInteresse(assTelasFormulario) {
        return this._http.post(`${this._env}/ven/areainteresse`, assTelasFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}